// 采购管理
export default [
  // {
  //   path: '/procure',
  //   meta: { title: '采购管理' },
  //   component: () => import('../views/procure/index'),
  //   children: [
  //     {
  //       path: '/procure/list',
  //       name: 'list',
  //       meta: { title: '商品列表', isMenu: true },
  //       component: () => import('../views/procure/list.vue'),
  //     },
  //     {
  //       path: '/procure/indent',
  //       name: 'indent',
  //       meta: { title: '购物车', isMenu: true },
  //       component: () => import('../views/procure/indent.vue'),
  //     },
  //     {
  //       path: '/procure/purchaseRecords',
  //       meta: { title: '进货记录', isMenu: true },
  //       component: () => import('../views/procure/purchaseRecords.vue'),
  //     },
  //     {
  //       path: '/procure/detail/info',
  //       meta: { title: '进货记录-查看' },
  //       component: () => import('../views/procure/detail/info.vue'),
  //     },
  //   ],
  // },
]
